export default __webpack_public_path__ + "static/media/features.5.7f7919e0.svg";